import {Pipe, PipeTransform} from '@angular/core';
import _ from 'underscore';

@Pipe({
  name: 'fullSort'
})
export class FullSortPipe implements PipeTransform {
  transform(array?: any[], field?: string, reverseArray?: boolean): any[] {

    // This is used for all filter selected.
    if (field === '') {
      field = 'post_name';

      if (reverseArray) {
        return Array.from(array as any).sort((item1: any, item2: any) => {
          return this.orderByComparator(item1[field as any], item2[field as any]);
        });
      } else {
        //not asc
        return Array.from(array as any).sort((item1: any, item2: any) => {
          return this.orderByComparator(item2[field as any], item1[field as any]);
        });
      }
    }

    if (field === 'date_created' || field === 'date_modified') {
      return reverseArray ? _.sortBy(array as any, function (o: any) {
        return o[field];
      }).reverse() : _.sortBy(array as any, function (o: any) {
        return o[field];
      });
    }

    if (field === 'report_highlighted') {
      console.log(_.where(array as any, {report_highlighted: 'highlighted'}));
      return _.where(array as any, {report_highlighted: 'highlighted'});
    }

    return reverseArray ? _.sortBy(array as any, field) : _.sortBy(array as any, field).reverse();
  }

  orderByComparator(a: any, b: any): number {

    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
      //Isn't a number so lowercase the string to properly compare
      if (a.toLowerCase() < b.toLowerCase()) return -1;
      if (a.toLowerCase() > b.toLowerCase()) return 1;
    } else {
      //Parse strings as numbers to compare properly
      if (parseFloat(a) < parseFloat(b)) return -1;
      if (parseFloat(a) > parseFloat(b)) return 1;
    }

    return 0; //equal each other
  }
}
